import Vue from "vue";
const vm = new Vue();

export const getFavoriteSizeBox = (courierCode) => {
    return new Promise((resolve, reject) => {
        vm.$http
        .get(vm.$API_URL + `/courier/${courierCode}/favBox`, {
            headers: {
                Token: localStorage.getItem("access_token"),
            }
        })
        .then((res) => {
            resolve(res.data.data);
        });
    });
};


export const createFavoriteSizeBox = async (courierCode, sizeCode) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .post(
          vm.$API_URL + `/courier/${courierCode}/favBox`,
          {
            size: sizeCode,
          },
          {
            headers: {
              Token: localStorage.getItem("access_token"),
            },
          }
        )
        .then((res) => {
          let data = res.data.data;
          if (!res.data.status) {
            reject(res.data.error);
          }
          resolve(data);
        });
    });
};

export const deleteFavoriteSizeBox = async (
    courierCode,
    boxId
) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .delete(vm.$API_URL + `/courier/${courierCode}/favBox/${boxId}`, {
          headers: {
            Token: localStorage.getItem("access_token"),
          }
        })
        .then((res) => {
          let data = res.data.data;
          if (!res.data.status) {
            reject(res.data.error.message);
          }
          resolve(data);
        });
    });
};
  